import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Check if Google Analytics gtag function is available (handles AdBlockers gracefully)
    if (typeof window.gtag === "function") {
      window.gtag("config", "G-J1JT10S65V", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}
